/**
 *  UserList.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// Tables
import { 
  PagingState, 
  IntegratedPaging,
  SearchState, 
  IntegratedFiltering, 
  SortingState, 
  IntegratedSorting, 
} from '@devexpress/dx-react-grid';
import { 
  Grid, 
  Table, 
  Toolbar, 
  TableHeaderRow, 
  PagingPanel, 
  SearchPanel 
} from "@devexpress/dx-react-grid-bootstrap3";

// notifications
import NotificationSystem from "react-notification-system";

// components
import DeforestationModal from "./DeforestationModal.jsx"

// style
import { style } from "../../variables/Variables.jsx";

// global
var firebase = require("../../firebase");
var utils = require("../../utils");

class DeforestationReportList extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        {name: "createdAt", title: "Criado em",
          getCellValue: row => utils.dateTimeFormatter(row.createdAt)
        },
        {name: "userName", title: "Usuário"},
        {name: "userPhone", title: "Telefone"},
        {name: "status", title: "Alerta",
          getCellValue: row => row.status === 1 ? <span className="badge-danger">ATIVO</span> : <span className="badge-success">DISPENSADO</span> 
        },
        {name: "actions", title: "Ações",
          getCellValue: row => this.actions(row)
        }
      ],
      showModal: false,
      rowSelected: null,
      _notificationSystem: null,
      indexSelected: null,
      lat: 0,
      lon: 0,
      searchValue: '',
      sortColumns: [],
      tableColumnExtensions: [
        { columnName: 'icon', width: 35 },
        { columnName: 'actions', width: 200 },
      ]
    };

    this.changeSearchValue = value => this.setState({ searchValue: value });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  handleClose = () => {
    this.setState({ showModal: false, selection: [] });
  }

  actions = (row) => { 
    return (
      <div>
        <a onClick={() => {this.getLocation(row)}} className="link-edit">
          <span className='text-warning' style={{fontWeight: 'bold'}}><i className={`glyphicon glyphicon-globe`} /> RASTREAR</span>
        </a>
        {" "}
        <a onClick={() => {this.disableReport(row)}} className="link-edit">
          <span className='text-danger' style={{fontWeight: 'bold'}}><i className={`glyphicon glyphicon-remove`} /> DISPENSAR</span>
        </a>
      </div>
    )
  }

  getLocation = (row) => {
    this.setState({ 
      rowSelected: row,
      showModal: true,
      lat: row.lat, 
      long: row.long, 
      url: "https://www.google.com/maps/embed/v1/search?q="+row.lat+"%2C%20"+row.long+"&key=AIzaSyBQY9mebdLSt8IRHgre47-X9sW6unp5NnE"
    });
  }

  disableReport = (row) => {
    const { reload } = this.props
    this.notify("Dispensado com sucesso", "success")
    firebase.database.ref(`reports/deforestation/${row.key}`).update({ status: 0 }).then( _ => {
      reload()
    })
  }
  
  notify = (message, level) =>  {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell" />,
      message: <div>{message}</div>,
      level: level,
      position: "tr",
      autoDismiss: 10
    });
  }

  render() {
    const { columns, searchValue, sortColumns, tableColumnExtensions, showModal, url, rowSelected } = this.state;
    const { reports, reload } = this.props
    
    return (
      <div> 
        {showModal && 
          <DeforestationModal
            show={showModal}
            handleHide={this.handleClose}
            url={url}
            rowSelected={rowSelected}
          />
        }

        <NotificationSystem ref="notificationSystem" style={style} />
      
        <Grid rows={reports} columns={columns}>
          <div
              style={{
                  position: "absolute",
                  zIndex: 1,
                  top: 143
              }}
          >
              <div className='col-auto pl-0'>
                  <button
                      type='button'
                      className='btn mr-2'
                      title='Recarregar'
                      onClick={reload}
                      style={{
                          border: 'none',
                          boxShadow: 'none',
                          outline: '0'
                      }}
                  >
                      <span><i className='glyphicon glyphicon-refresh'/> Recarregar</span>
                  </button>
              </div>
          </div>
          <SearchState
            value={searchValue}
            onValueChange={this.changeSearchValue}
          />

          <PagingState
            defaultCurrentPage={0}
            defaultPageSize={20}
          />

          <SortingState
            defaultSorting={sortColumns}
          />
          
          <IntegratedFiltering />
          <IntegratedSorting />
          <IntegratedPaging />
          
          <Table columnExtensions={tableColumnExtensions} />
            <TableHeaderRow showSortingControls />
          <Toolbar />

          <SearchPanel/>
          
          <PagingPanel
            pageSizes={[5, 15, 20, 25, 50, 100, 0]}
          />
        </Grid>
      </div>
    );
  }
}

export default DeforestationReportList;



// WEBPACK FOOTER //
// ./src/views/DeforestationReport/DeforestationReportList.jsx